import { render, staticRenderFns } from "./productCatalog.vue?vue&type=template&id=30b2103e&"
import script from "./productCatalog.vue?vue&type=script&lang=js&"
export * from "./productCatalog.vue?vue&type=script&lang=js&"
import style0 from "./productCatalog.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports